var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1C3.92508 1 1 3.92508 1 7.5C1 11.0749 3.92508 14 7.5 14C11.0749 14 14 11.0749 14 7.5C14 3.92508 11.0749 1 7.5 1ZM7.5 13.1333C4.40174 13.1333 1.86667 10.5983 1.86667 7.5C1.86667 4.40174 4.40167 1.86667 7.5 1.86667C10.5983 1.86667 13.1333 4.40167 13.1333 7.5C13.1333 10.5983 10.5982 13.1333 7.5 13.1333ZM7.06671 6.98333H7.9333V11.4H7.06671V6.98333ZM8.15004 4.46671C8.15004 4.83502 7.86833 5.11674 7.5 5.11674C7.13167 5.11674 6.84996 4.83503 6.84996 4.46671C6.84996 4.09839 7.13167 3.81667 7.5 3.81667C7.86833 3.81667 8.15004 4.09823 8.15004 4.46671Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.d5de4051.svg";
export { ForwardRef as ReactComponent };